"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = exports.StyledPagination = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledPagination = (0, styled_components_1.default)(antd_1.Pagination) `
	& {
		text-align: center;
	}
	.ant-pagination-item,
	.ant-pagination-next .ant-pagination-item-link,
	.ant-pagination-prev .ant-pagination-item-link {
		border-radius: 0.4rem;
	}
`;
const Pagination = (props) => {
    return (0, jsx_runtime_1.jsx)(exports.StyledPagination, { ...props });
};
exports.Pagination = Pagination;
